<template>
  <div>
    <Navigation />
    <div class="wrap">
      <div class="head">
        <div><h1>Suppliers</h1><p class="lede">{{ suppliers.length }} supplier{{ suppliers.length === 1 ? '' : 's' }} on file.</p></div>
        <button class="primary" @click="openNew" v-if="canEdit">+ New supplier</button>
      </div>

      <div class="card">
        <table v-if="suppliers.length">
          <thead><tr><th>Name</th><th>Contact</th><th>Phone</th><th>Email</th><th>Terms</th><th></th></tr></thead>
          <tbody>
            <tr v-for="s in suppliers" :key="s.id">
              <td><strong>{{ s.name }}</strong></td>
              <td>{{ s.contact_person || '—' }}</td>
              <td>{{ s.phone || '—' }}</td>
              <td class="muted">{{ s.email || '—' }}</td>
              <td class="muted small">{{ s.payment_terms || '—' }}</td>
              <td>
                <button class="secondary small" @click="openEdit(s)" v-if="canEdit">Edit</button>
                <button class="danger small" style="margin-left:6px" @click="remove(s)" v-if="canEdit">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else class="muted center">No suppliers yet. Add your first supplier so you can raise purchase orders.</p>
      </div>
    </div>

    <div v-if="showForm" class="modal-back" @click.self="showForm=false">
      <div class="modal card">
        <h3>{{ form.id ? 'Edit Supplier' : 'New Supplier' }}</h3>
        <label>Business name</label><input v-model="form.name" required />
        <label>Contact person</label><input v-model="form.contactPerson" />
        <div class="row-2">
          <div><label>Phone</label><input v-model="form.phone" placeholder="0712345678" /></div>
          <div><label>Email</label><input v-model="form.email" type="email" /></div>
        </div>
        <label>Address</label><input v-model="form.address" />
        <div class="row-2">
          <div><label>Tax PIN</label><input v-model="form.taxPin" /></div>
          <div><label>Payment terms</label><input v-model="form.paymentTerms" placeholder="Net 30, COD..." /></div>
        </div>
        <div class="modal-actions">
          <button class="secondary" @click="showForm=false">Cancel</button>
          <button class="primary" @click="save" :disabled="saving">{{ saving ? 'Saving…' : 'Save' }}</button>
        </div>
        <p class="err" v-if="err">{{ err }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/paysol-nav/Navigation.vue';
import { paysol, execute, can } from '@/api';

export default {
  name: 'SupplierManagement',
  components: { Navigation },
  data() {
    return {
      suppliers: [],
      showForm: false, saving: false, err: '',
      form: { id: 0, name: '', contactPerson: '', phone: '', email: '', address: '', taxPin: '', paymentTerms: '' },
    };
  },
  computed: {
    canEdit() { return can('suppliers.edit') || sessionStorage.getItem('userRole') === 'owner' || sessionStorage.getItem('userRole') === 'manager'; },
  },
  async mounted() { await this.load(); },
  methods: {
    async load() {
      const { data } = await execute({ function: 'listSuppliers' }, paysol);
      if (data.success) this.suppliers = data.data;
    },
    openNew() {
      this.form = { id: 0, name: '', contactPerson: '', phone: '', email: '', address: '', taxPin: '', paymentTerms: '' };
      this.err = ''; this.showForm = true;
    },
    openEdit(s) {
      this.form = {
        id: s.id, name: s.name || '', contactPerson: s.contact_person || '',
        phone: s.phone || '', email: s.email || '', address: s.address || '',
        taxPin: s.tax_pin || '', paymentTerms: s.payment_terms || '',
      };
      this.err = ''; this.showForm = true;
    },
    async save() {
      this.saving = true; this.err = '';
      try {
        const { data } = await execute({ function: 'saveSupplier', ...this.form }, paysol);
        if (!data.success) { this.err = data.message; return; }
        this.showForm = false;
        await this.load();
      } catch (e) { this.err = e.response?.data?.message || 'Save failed.'; }
      finally { this.saving = false; }
    },
    async remove(s) {
      if (!confirm(`Delete "${s.name}"?`)) return;
      const { data } = await execute({ function: 'deleteSupplier', id: s.id }, paysol);
      if (data.success) { alert(data.message); await this.load(); }
      else alert(data.message);
    },
  }
};
</script>

<style scoped>
.wrap { max-width: 1100px; margin: 0 auto; padding: 24px; }
.head { display: flex; justify-content: space-between; align-items: end; margin-bottom: 20px; }
h1 { font-size: 26px; margin: 0 0 4px; color: var(--paysol-text); }
.lede { color: var(--paysol-muted); margin: 0; }
.muted { color: var(--paysol-muted); } .small { font-size: 11px; }
.center { text-align: center; padding: 40px 0; }
button.small { padding: 4px 10px; font-size: 11px; }
.modal-back { position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 50; padding: 24px; }
.modal { width: 100%; max-width: 500px; }
.row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px; padding-top: 14px; border-top: 1px solid var(--paysol-line); }
.err { color: var(--paysol-danger); font-size: 12px; margin-top: 8px; }
</style>
